export default __webpack_public_path__ + "static/media/jpgIcon.642eca78.svg";